import { Box, FlexDiv } from 'components/molecules/utils/basicComponents';
import Tooltip from 'components/tooltip/Tooltip';
import Icon from 'foundations/icon';
import { Typography } from 'foundations/typography';
import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { StyledSvgSprite } from '../../../../general/SVGSprite';

export const SocialLounge = ({
    formData,
    showSidemenu,
    setShowSideMenu,
    error,
    isCreateAirmeetV3,
}) => {
    return (
        <Box>
            <Box mb={2}>
                <Typography variant={'subtext1'} color={'ambience.0'} mb={0}>
                    Additional details
                </Typography>
                <Typography variant={'caption'} color={'ambience.14'}>
                    Enable and manage the social lounge
                </Typography>
            </Box>
            <Box>
                <StyledFlexDiv removeBorder={isCreateAirmeetV3}>
                    <FlexDiv>
                        <FlexDiv mr={'34px'}>
                            <Typography
                                variant={'subtext2'}
                                color={'ambience.6'}
                            >
                                Social lounge
                            </Typography>
                            <ToolTipStyle />
                            <Tooltip
                                toolClass='eventFlowToolTip attendeeTheme infoeventTheme dashboard-tooltip'
                                place='right'
                                renderElement={
                                    <Box className={'detail'}>
                                        <Typography
                                            variant={'subtext1'}
                                            color={'ambience.23'}
                                            mb={1}
                                        >
                                            What is Social Lounge?
                                        </Typography>
                                        <Typography
                                            variant={'subtext2'}
                                            color={'ambience.14'}
                                        >
                                            Your participants can interact with
                                            each other over video calls in
                                            virtual tables at the Social Lounge
                                        </Typography>
                                    </Box>
                                }
                                className={'eventFlowToolTip-container'}
                                renderTrigger={
                                    <Icon
                                        icon='info'
                                        width='16px'
                                        height='16px'
                                        fill='ambience.15'
                                        position='relative'
                                        ml={'5px'}
                                    />
                                }
                            />
                        </FlexDiv>
                    </FlexDiv>
                    <ArrowBox
                        className={showSidemenu === 'social_lounge' && 'active'}
                        showSidemenu={showSidemenu !== ''}
                        onClick={() => setShowSideMenu('social_lounge')}
                        error={error}
                        sidebarIsOpen={showSidemenu !== 'social_lounge'}
                    >
                        <FlexDiv alignItems={'center'} flex={1}>
                            <WithIconBox mr={'34px'}>
                                <StyledSvgSprite
                                    icon={
                                        formData.hasVirtualTables
                                            ? 'icon-green-allowed'
                                            : 'icon-not-allowed'
                                    }
                                />
                                <Typography
                                    variant={'subtext1'}
                                    color={'ambience.1'}
                                >
                                    {formData.hasVirtualTables
                                        ? 'Enabled for this event'
                                        : 'Not enabled for this event'}
                                </Typography>
                                {formData.hasVirtualTables &&
                                    formData.tableCount !== '' && (
                                        <StyledTableCounter
                                            variant={'subtext2'}
                                            color={'ambience.6'}
                                        >
                                            {formData.tableCount}
                                        </StyledTableCounter>
                                    )}
                            </WithIconBox>
                        </FlexDiv>
                        <ArrowButton
                            variant={'body1'}
                            className={
                                showSidemenu === 'social_lounge' && 'active'
                            }
                        >
                            <StyledSvgSprite
                                icon={'chevron_right'}
                                height={'16px'}
                                fill={'ambience.6'}
                                width={'16px'}
                            />
                        </ArrowButton>
                    </ArrowBox>
                </StyledFlexDiv>
            </Box>
        </Box>
    );
};

const StyledFlexDiv = styled(FlexDiv)`
    padding: 8px 0 8px 8px;
    border-bottom: ${({ removeBorder, theme }) =>
        removeBorder ? '0px' : `1px solid ${theme.colors.ambience[20]}`};
    position: relative;
    align-items: center;
    justify-content: space-between;
`;
const WithIconBox = styled(FlexDiv)`
    position: relative;
    padding-left: ${({ timezone }) => (timezone ? '32px' : '28px')};
    svg {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        height: ${({ timezone }) => (timezone ? '24px' : '20px')};
        width: ${({ timezone }) => (timezone ? '24px' : '20px')};
        left: 2px;
        fill: ${({ theme }) => theme.colors.ambience[19]};
    }
`;

const ToolTipStyle = createGlobalStyle`
    .eventFlowToolTip-container{
        display: flex;
        align-items: center;
        cursor : pointer;
    }
    #root .eventFlowToolTip .detail{
        width: 100% !important;
        min-width: 262px;
        max-width: 262px;
        padding: 16px 24px !important;
    }
`;
const StyledTableCounter = styled(Typography)`
    margin-left: 8px;
    padding-left: 12px;
    position: relative;
    &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 4px;
        width: 4px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.ambience[14]};
    }
`;

const ArrowButton = styled(Typography)`
    height: 32px;
    width: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    &:hover,
    &.active {
        background-color: ${({ theme }) => theme.colors.ambience[23]};
    }
`;

const ArrowBox = styled(FlexDiv)`
    cursor: pointer;
    position: relative;
    justify-content: space-between;
    flex: 1;
    align-items: center;
    padding: 16px 10px;
    border-radius: 8px;
    transition: all 0.3s ease-in-out;
    &:hover {
        background-color: ${({ theme }) => theme.colors.ambience[20]};
        > p {
            background-color: ${({ theme }) => theme.colors.ambience[23]};
        }
    }
    &:active,
    &:focus,
    &:focus-within {
        box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.ambience[19]};
        background-color: ${({ theme }) => theme.colors.ambience[20]};
    }
    ${ArrowButton} {
        &:focus {
            outline: 0;
        }
    }
    ${({ theme, showSidemenu }) =>
        showSidemenu &&
        `
    &::before{
        content: '';
        position: absolute;
        top: 50%;
        right: -70px;
        opacity: 0;
        height: 48px;
        width: 48px;
        transform: translate(400px,-50%) rotate(45deg);
        border-radius: 4px;
        background-color: ${theme.colors.ambience[2]};
        z-index: 0;
        transition: all 0.35s ease-in-out;
    }
    &.active::before {
        opacity:1;
        transform: translate(0px,-50%) rotate(45deg);
    }
    `};
    ${({ error, sidebarIsOpen, theme }) =>
        sidebarIsOpen &&
        error &&
        `
        box-shadow: 0 0 0 1px ${theme.colors.semantic[1]};
        &:focus,
        &:focus-within {
            box-shadow: 0 0 0 1px ${theme.colors.semantic[1]};
        }
    `};
`;
